import React from 'react';

import { Flex, useTheme } from '@chakra-ui/react';
import { useIsNetchexNewNavAndAdminOrManagerPage } from 'Deer/hooks/useIsNetchexNewNavAndAdminOrManagerPage';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isMobileView } from 'constants/isMobileView';
import {
  NETCHEX_NEW_ICON_ONLY_SIDEPANEL_WIDTH,
  NETCHEX_SIDEPANEL_WIDTH,
  isNetchexLogin,
} from 'constants/netChexConstants';

import { Button } from 'uiToolkitV1/Button';
import { TextLabel } from 'uiToolkitV1/Typography';

import { goalPreferencesActions, useGoalPreferencesContext } from '../context/GoalPreferencesProvider';

const Footer = () => {
  const theme = useTheme();

  const { isNetchexNewSidePanelCollapsed, isNetchexNewSideNav } = useIsNetchexNewNavAndAdminOrManagerPage();

  const { state, goalPreferenceDispatch, saveChanges, cancelChanges } = useGoalPreferencesContext();

  const { isGoalsFreqUpdated, isCheckinReminderUpdated, isTemplateConfigUpdated } = state;

  const isDisabled = isGoalsFreqUpdated || isCheckinReminderUpdated || isTemplateConfigUpdated;

  const openSaveModal = () => {
    goalPreferenceDispatch({
      type: goalPreferencesActions.UPDATE_CONFIRMATION_MODAL,
      payload: {
        isOpen: true,
        heading: 'Save Changes',
        text: 'Are you sure you want to save these modifications to settings?',
        onSuccess: saveChanges,
      },
    });
  };

  const openCancelModal = () => {
    goalPreferenceDispatch({
      type: goalPreferencesActions.UPDATE_CONFIRMATION_MODAL,
      payload: {
        isOpen: true,
        heading: 'Cancel Changes',
        text: 'Exiting the page would lose you on the recent changes. Are you sure you want to exit?',
        onSuccess: cancelChanges,
      },
    });
  };

  let netchexNewNavWidth = '100%';
  if (isNetchexNewSideNav) {
    netchexNewNavWidth = isNetchexNewSidePanelCollapsed
      ? `calc(100% - ${NETCHEX_NEW_ICON_ONLY_SIDEPANEL_WIDTH})`
      : `calc(100% - ${NETCHEX_SIDEPANEL_WIDTH})`;
  }

  const getFooterWidth = () => {
    if (checkNewNavEnabled()) {
      if (isNetchexLogin) {
        return netchexNewNavWidth;
      }
      return '100%';
    }
    if (isMobileView()) {
      return '100%';
    }
    return 'calc(100vw - 241px)';
  };

  return (
    <Flex
      bgColor={theme.colors.surface.F5F7F9}
      alignItems="center"
      justifyContent="flex-end"
      paddingRight={4}
      position={checkNewNavEnabled() ? 'static' : 'fixed'}
      bottom={checkNewNavEnabled() ? null : 0}
      width={getFooterWidth()}
      columnGap={4}
      paddingY={6}
      sx={{
        position: isNetchexLogin ? 'fixed' : null,
        bottom: 0,
      }}
    >
      <Flex flexDir="column" width="100%" p="0 16px">
        {isNetchexLogin && (
          <TextLabel bold pb="12px">
            Note: Changes made here will apply across all companies in the organization.
          </TextLabel>
        )}
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Button onClick={openCancelModal} variant="outlined" disabled={!isDisabled}>
            Cancel
          </Button>

          <Button onClick={openSaveModal} disabled={!isDisabled}>
            Save
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Footer;
